<div class="mb-3">
  <label class="form-label d-flex align-items-center fw-semibold text-label">
    <span>Role <span class="required-dot">●</span></span>
    @if(isLoading) {
    <span class="spinner-border spinner-border-sm text-teal ms-2" role="status">
      <span class="visually-hidden">Loading roles...</span>
    </span>
    }
  </label>

  <select class="form-select custom-select" [class.is-invalid]="hasError" [disabled]="isLoading" [ngModel]="value || ''"
    (change)="onSelectChange($event)">
    <option value="" disabled selected>Select a role...</option>
    @for(role of roles; track role.id) {
    <option [value]="role.id">
      {{ role.name }}
    </option>
    }
  </select>

  @if(hasError) {
  <div class="error-message mt-1">
    Role is required
  </div>
  }
</div>